export const SUPPORT_PATH = "/apps/support";

export const TICKETS_LIST_PATH = `${SUPPORT_PATH}/tickets/list`;
export const getTicketViewPath = (id: string | number) =>
  `${SUPPORT_PATH}/tickets/view/${id}`;

export const FEEDBACK_LIST_PATH = `${SUPPORT_PATH}/feedback/list`;
export const getFeedbackViewPath = (id: string | number) =>
  `${SUPPORT_PATH}/feedback/view/${id}`;

export const HELPDESK_LIST_PATH = `${SUPPORT_PATH}/helpdesk/list`;
export const getHelpdeskViewPath = (id: string | number) =>
  `${SUPPORT_PATH}/helpdesk/view/${id}`;
